import React, {useState} from "react";
import Sidebar from "../sidebar/Sidebar";
import MyNavBar from "../navbar/Navbar";
import {Outlet} from "react-router-dom";

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleIsOpen = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggleIsOpen} />
            <MyNavBar toggle={toggleIsOpen} />
            <Outlet />
        </>
    );
}

export default Home;
